import { generateWindowIframeId } from './generateWindowIframeId'

export const getWindowIframe = (windowId: string) => {
  const iframeId = generateWindowIframeId(windowId)
  return document.getElementById(iframeId) as HTMLIFrameElement | null
}
